import { gql } from '@apollo/client';

export const REGISTER_FOR_OLYMPIAD = gql`
  mutation registerForOlympiad(
    $secondName: String
    $patronymic: String
    $name: String!
    $email: String!
    $phone: String!
    $password: String
    $utmData: JSON
    $emailMe: Boolean
    $recommendedContactMethod: String
    $landerCode: String!
    $sendLead: Boolean
    $onlyRegistration: Boolean
    $classNumber: String
    $phoneStatus: PhoneStatusEnum
    $birthdate: ISO8601Date
    $childName: String!
    $childSecondName: String
    $childPatronymic: String
    $ageGroup: String!
  ) {
    registerForOlympiad(
      secondName: $secondName
      patronymic: $patronymic
      name: $name
      email: $email
      phone: $phone
      password: $password
      utmData: $utmData
      emailMe: $emailMe
      recommendedContactMethod: $recommendedContactMethod
      landerCode: $landerCode
      sendLead: $sendLead
      onlyRegistration: $onlyRegistration
      classNumber: $classNumber
      phoneStatus: $phoneStatus
      birthdate: $birthdate
      childName: $childName
      childSecondName: $childSecondName
      childPatronymic: $childPatronymic
      ageGroup: $ageGroup
    ) {
      success
      errors {
        message
        objectField
        valid
      }
      user {
        id
        token
      }
    }
  }
`;

export const GET_PUBLISHED_OLYMPIAD_PACKS = gql`
  query getPublishedOlympiadPacks {
    getPublishedOlympiadPacks {
      endsAt
      id
      landerCode

      olympiads {
        ageGroup
        tAgeGroup
        expandedStatus
        id
        image { url }
        published
        status
        topic
      }

      subject {
        id
        name
      }

      published
      startsAt
      status
      title
    }
  }
`;

export const GET_OLYMPIAD_PACK_BY_ID = gql`
  query getOlympiadPackById($id: ID!) {
    getOlympiadPackById(id: $id) {
      endsAt
      id
      # image { url }
      # info
      # lander
      landerCode

      olympiads {
        ageGroup
        tAgeGroup
        id
      }

      published
      # resultsAt
      startsAt
      status
      title
    }
  }
`;

export const GET_OLYMPIAD_BY_ID = gql`
  query getOlympiadById($id: ID!) {
    getOlympiadById(id: $id) {
      # accessible
      ageGroup
      tAgeGroup
      averageScore
      expandedStatus
      id
      image { url }

      olympiadPrizePositions {
        position
        olympiadPrize {
          description
          id
          image { url }
          title
        }
      }
      openingScreen{
        url
      }
      published
      status
      topic
    }
  }
`;

export const LOGIN = gql`
  mutation signIn($email: String!, $password: String!, $remember: Boolean) {
    signIn(email: $email, password: $password, rememberMe: $remember) {
      user {
        id
        token
      }

      success
      errors {
        message
      }
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      errors {
        message
      }
      success
    }
  }
`;

export const REGISTER_SELF = gql`
  mutation selfSignUp(
    $name: String!
    $email: String!
    $phone: String!
    $landerCode: String
    $utmData: JSON
  ) {
    selfSignUp(
      name: $name
      email: $email
      phone: $phone
      utmData: $utmData
      landerCode: $landerCode
    ) {
      success
      errors {
        message
        objectField
      }
      user {
        id
        token
        type
      }
    }
  }
`;
